import { registerArchetype } from './index.js';
import { livingAllies, getRuntimes } from '../combat.js';
const REMOVABLE = ['debuff', 'dot', 'silence', 'stun'];
registerArchetype({
    id: 'cleanse',
    apply: ({ state, source, params }) => {
        const targetMode = params.target ?? 'self';
        const allies = livingAllies(state, source.side);
        const targets = targetMode === 'all_allies'
            ? allies
            : targetMode === 'self' ? [{ slot: source.slot, runtime: getRuntimes(state, source.side)[source.slot] }] : allies;
        for (const t of targets) {
            const rt = getRuntimes(state, source.side)[t.slot];
            const before = rt.statuses.length;
            rt.statuses = rt.statuses.filter(s => !REMOVABLE.includes(s.kind));
            if (rt.statuses.length !== before) {
                state.events.push({ t: state.tick, kind: 'status_expire', side: source.side, slot: t.slot, status: 'cleanse' });
            }
        }
    }
});
